import {
  Component,
  Input,
  Output,
  EventEmitter,
  Injectable,
  ViewEncapsulation,
  OnDestroy,
} from "@angular/core";
import {
  chevronDown,
  folderOpen,
  save,
  edit,
  trash,
  slidersHorizontal,
  VAIconRegistryService,
  circle,
  infoCircle,
} from "@va/core-library/icons";
import { PharmaDataService } from "../pharma-data.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { Router } from "@angular/router";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
@Component({
  selector: "app-database-page-sider",
  templateUrl: "./database-page-sider.component.html",
  styleUrls: ["./database-page-sider.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
@Injectable({
  providedIn: "root",
})
export class DatabasePageSiderComponent implements OnDestroy {
  selectedSavedFilter;

  @Input() collapsedSider;
  @Output() collapseEvent = new EventEmitter<boolean>();

  // collapsedSider: boolean = false;
  savedFilterList = [];
  currentFilterObj: any;
  lastSavedFilterObj: any;
  setFilterObj: any;
  deletedFilterObj: any;
  showSavedFilterModal = false;
  savedFilterError = false;
  filterNameError = false;
  loadingSavedFilters = false;
  currentFilterName = "";
  displayFilterName = "";
  showChangeBadge = false;
  showSaveAsNameModal = false;
  showDeleteModal = false;
  defaultFilterName = "My Filter";
  pharmaDatabasePageSubscriber: Subscription;
  updateFilterSubscriber: Subscription;
  saveFilterSubscriber: Subscription;
  getAllSavedFilterSubscriber: Subscription;
  deleteFilterSubscriber: Subscription;
  nameError: any;
  constructor(
    private iconRegistryService: VAIconRegistryService,
    private router: Router,
    private message: NzMessageService,
    private service: PharmaDataService,
    private store: Store<AppState>,
  ) {
    this.iconRegistryService.registerIcons([
      save,
      folderOpen,
      chevronDown,
      slidersHorizontal,
      edit,
      trash,
      circle,
      infoCircle,
    ]);
  }

  ngOnInit() {
    this.showSavedFilterModal = false;
    this.pharmaDatabasePageSubscriber = this.store
      .select(stateGetter("pharmaDatabasePage"))
      .subscribe((data: any) => {
        this.setFilterObj = data.facetFilters;
        this.currentFilterObj = { ...this.setFilterObj };
        if (data.filterEvent.source === "saved-filter") {
          this.selectedSavedFilter = data.savedFilter;
          this.lastSavedFilterObj = this.selectedSavedFilter.json_data;
          this.setFilterObj = { ...this.selectedSavedFilter.json_data };
          this.displayFilterName = this.selectedSavedFilter.filter_name;
          this.showChangeBadge = false;
          return;
        }
        if (
          data.filterEvent.filterChanged === "facet" ||
          data.filterEvent.filterChanged === "chart"
        ) {
          this.showChangeBadge = true;
        }
      });
  }

  toggleSider() {
    this.collapsedSider = !this.collapsedSider;
    this.collapseEvent.emit(this.collapsedSider);
  }

  ngOnDestroy(): void {
    if (this.pharmaDatabasePageSubscriber) {
      this.pharmaDatabasePageSubscriber.unsubscribe();
    }
    if (this.updateFilterSubscriber) {
      this.updateFilterSubscriber.unsubscribe();
    }
    if (this.saveFilterSubscriber) {
      this.saveFilterSubscriber.unsubscribe();
    }
    if (this.getAllSavedFilterSubscriber) {
      this.getAllSavedFilterSubscriber.unsubscribe();
    }
    if (this.deleteFilterSubscriber) {
      this.deleteFilterSubscriber.unsubscribe();
    }
  }
}
